import { Link } from 'react-router';
import { AlertTriangle, Clock, ArrowRight } from 'lucide-react';
import { useSubscriptionStatus } from '../context/SubscriptionContext';
import { useDarkMode } from '../context/DarkModeContext';
import { useAuth } from '../context/AuthContext';
import { buildExpiryNotices } from '../lib/expiry-notices';

export function ExpiryBanner() {
  const { status, loading } = useSubscriptionStatus();
  const { darkMode } = useDarkMode();
  const { user } = useAuth();

  if (loading || !status || user?.isAdmin) return null;

  const notices = buildExpiryNotices(status);
  if (notices.length === 0) return null;

  return (
    <div className="flex flex-col gap-2 px-4 pt-3">
      {notices.map((notice, idx) => {
        const isExpired = notice.severity === 'expired';
        const Icon = isExpired ? AlertTriangle : Clock;
        const colorClasses = isExpired
          ? darkMode
            ? 'bg-red-900/30 border-red-800 text-red-200'
            : 'bg-red-50 border-red-200 text-red-900'
          : darkMode
            ? 'bg-amber-900/30 border-amber-800 text-amber-200'
            : 'bg-amber-50 border-amber-200 text-amber-900';
        const iconColor = isExpired
          ? darkMode ? 'text-red-400' : 'text-red-600'
          : darkMode ? 'text-amber-400' : 'text-amber-600';
        const buttonClasses = isExpired
          ? 'bg-red-600 hover:bg-red-700 text-white'
          : 'bg-amber-600 hover:bg-amber-700 text-white';

        return (
          <div
            key={idx}
            className={`flex items-center gap-3 rounded-lg border px-4 py-3 ${colorClasses}`}
          >
            <Icon className={`w-5 h-5 flex-shrink-0 ${iconColor}`} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold">{notice.title}</p>
              <p className="text-sm opacity-90">{notice.message}</p>
            </div>
            <Link
              to="/preise"
              className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap ${buttonClasses}`}
            >
              Jetzt verlängern
              <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        );
      })}
    </div>
  );
}
